module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account container-fluid"
  }, [_c('div', {
    staticClass: "bind-and-change-pwd"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('settings')))]), _vm._v(" "), _c('bind'), _vm._v(" "), _c('change-password', {
    staticClass: "change-pwd"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subscription"
  }, [_c('subscription')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-746c1a29!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/Settings.vue
// module id = 1355
// module chunks = 1